import { Link } from "react-router-dom";

const PipsTradeAppContentThree = () => {
  return (
    <div className="how__work__platform">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="content-left">
              <h2>Trade Anywhere, Without Limits</h2>
              <p>
                The Pips Terminal is fully web-based and compatible with
                Windows, macOS, and Linux. Log in securely from any browser, no
                installation required, and enjoy full synchronization with your
                mobile and desktop sessions. Your trading workspace follows you
                seamlessly, ensuring uninterrupted control no matter where you
                are. The platform is optimized for speed and stability,
                delivering smooth performance even on lower-spec devices or
                fluctuating networks. Whether you're traveling, multitasking, or
                monitoring markets on the go, The Pips Terminal keeps you
                connected without compromise.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Access The Terminal Now
              </Link>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="thumb-right">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/platforms/pips_terminal/pips_terminal_2.png"
                }
                alt="computer images"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PipsTradeAppContentThree;
